/* template */
<template><svg width="9px" height="16px" viewBox="0 0 9 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="arrow-right"><path :fill="(color)" d="M8.70906135,8.70075887 L1.69379375,15.7093387 C1.30587554,16.0968871 0.677864741,16.0968871 0.290938654,15.7093387 C-0.0969795513,15.3227815 -0.0969795513,14.6953694 0.290938654,14.307821 L6.6047787,8 L0.290938654,1.69217903 C-0.0969795513,1.30463063 -0.0969795513,0.677218523 0.290938654,0.290661298 C0.677864741,-0.0968870993 1.30587554,-0.0968870993 1.69379375,0.290661298 L8.70906135,7.29924113 C9.09697955,7.68579836 9.09697955,8.31420164 8.70906135,8.70075887 Z"></path></svg></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'ArrowRight',
  properties: {
    color: {
      type: String,
      value: '#FFE895',
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "arrow-right75d32029",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
